import React, { useState } from "react"

import { XCircleIcon as OutlineCircle } from "@heroicons/react/24/outline"
import { XCircleIcon as SolidCircle } from "@heroicons/react/24/solid"

import classNames from "src/classNames"

const RemoveButton = props => {
  const [active, setActive] = useState(false)
  const { onClick, disabled, className } = props
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "m-0 mr-3 flex h-10 min-h-[2rem] w-10 min-w-[2rem] items-center justify-center border-none bg-transparent p-1",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        className
      )}
      onMouseEnter={() => {
        if (!disabled) setActive(true)
      }}
      onMouseLeave={() => setActive(false)}
      disabled={disabled}
    >
      {active ? (
        <SolidCircle className="h-full w-full bg-transparent text-red-500" />
      ) : (
        <OutlineCircle
          className={classNames(
            "h-full w-full bg-transparent",
            disabled ? "text-gray-400" : "text-red-500"
          )}
        />
      )}
    </button>
  )
}

export default RemoveButton
